module.exports = __webpack_public_path__ + "static/media/bg-image-1.46f9f594.jpg";